import { Theme } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { shallowEqual } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import MenuResetApScheduler from '../../../components/Contact/Communicator/MenuResetApScheduler/MenuResetApScheduler';
import { ApSchedulerBuildStage } from '../../../sic-lib/enums/ApSchedulerBuildStage';
import { useAppSelector } from '../../../store/hooks';

const useStyles = makeStyles()((theme: Theme) => ({
    headerWrapper: {
        /* buttons are roughly 52px each */
        maxWidth: 'calc(100% - 104px)',
        overflow: 'hidden',
    },
}));

export default function Toolbar() {
    const { classes } = useStyles();

    const store = useAppSelector(state => {
        return {
            buildStage: state.communicator?.buildStage || ApSchedulerBuildStage.edit,
            template: state.communicator?.template || null,
            contacts: state.communicator?.contacts || [],
        };
    }, shallowEqual);

    const handleAssign = () => {
        //dispatch(apSchedulerActions.requestAssignTemplate());
    };

    const handleScheduleAll = () => {
        //dispatch(apSchedulerActions.requestBatchSchedule());
    };

    return (
        <Grid container direction="row" wrap="nowrap" alignItems="center" spacing={2}>
            <Grid item xs={true} className={classes.headerWrapper}>
                <Typography variant="h6" component="h2" noWrap>
                    {store.template?.title || ''}
                </Typography>
            </Grid>
            <Grid item xs="auto">
                <MenuResetApScheduler />
            </Grid>
            {store.buildStage === ApSchedulerBuildStage.edit && (
                <Grid item xs="auto">
                    <Button
                        onClick={handleAssign}
                        variant="outlined"
                        color="secondary"
                        disabled={
                            store.template === null ||
                            store.template?.actions.length < 1 ||
                            store.contacts.length < 1
                        }
                    >
                        Assign as draft
                    </Button>
                </Grid>
            )}
            {store.buildStage === ApSchedulerBuildStage.schedule && (
                <Grid item xs="auto">
                    <Button onClick={handleScheduleAll} variant="outlined" color="secondary">
                        Schedule All
                    </Button>
                </Grid>
            )}
        </Grid>
    );
}
